<template>
	<div class="flex items-center p-6 gap-x-6">
		<ui-icon name="alert-triangle" class="flex-shrink-0 h-12" />
		<div class="space-y-6 text-xl" v-if="locale == 'de'">
			<!-- <h2 class="text-2xl font-semibold text-gray-900">Stammdaten nicht vollständig</h2> -->
			<p>
				Bevor Sie alle Funktionen nutzen können, müssen Sie Ihr Benutzerprofil
				vervollständigen!
			</p>
		</div>
		<div v-else class="space-y-6 text-xl">
			<!-- <h2 class="text-2xl font-semibold text-gray-900">Data not complete</h2> -->
			<p>
				Before you can use all cropspot features, you need to complete your user
				profile!
			</p>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		imageUrl: () => window.baseUrl + "/images/full-features-screenshot.png",
	},
};
</script>
